import axios from "axios"

export const getProvinsi = async () => {
  const finalUrl =
      window._HOST + "public/provinsi"

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const getKabupaten = async (idProvinsi) => {
  const finalUrl =
      window._HOST + "public/kabupaten/?id-provinsi="+idProvinsi

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const getKecamatan = async (idKabupaten) => {
  const finalUrl =
      window._HOST + "public/kecamatan/?id-kabupaten="+idKabupaten

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const uploadPhoto = async (file) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    },
    withCredentials: true
  }

  const formData = new FormData()
  formData.append('photo', file)

  const response =
    await axios.post(
      window._HOST + 'participant/photo',
      formData,
      config
    )

  return response.data
}

export const updateBiodata = async (payload) => {
  const finalUrl =
      window._HOST + "participant/biodata"

  const response =
      await axios.put(finalUrl, payload)

  return response.data
}

export const updateFormBiodata = async (payload) => {
  const finalUrl =
      window._HOST + "participant/form-biodata"

  const response =
      await axios.put(finalUrl, payload)

  return response.data
}


export const getForm = async () => {
  const finalUrl =
      window._HOST + "participant/form-master"

  const response =
      await axios.get(finalUrl)

  return response.data  
}

export const setPurchasEventSent = async (payload) => {
  const finalUrl =
      window._HOST + "participant/purchase-event-sent"

  const response =
      await axios.put(finalUrl)

  return response.data
}